var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0428 6.35582C13.4355 6.35582 13.7539 6.03744 13.7539 5.6447C13.7539 5.25197 13.4355 4.93359 13.0428 4.93359H1.66502C1.27228 4.93359 0.953906 5.25197 0.953906 5.6447C0.953906 6.03744 1.27228 6.35582 1.66502 6.35582H13.0428Z",
    fill: "#00917D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43625 1.88093C6.71396 1.60323 6.71396 1.15298 6.43625 0.875272C6.15855 0.597566 5.70829 0.597566 5.43059 0.875272L1.16392 5.14194C0.886214 5.41964 0.886214 5.8699 1.16392 6.1476L5.43059 10.4143C5.70829 10.692 6.15855 10.692 6.43625 10.4143C6.71396 10.1366 6.71396 9.68631 6.43625 9.4086L2.67242 5.64477L6.43625 1.88093Z",
    fill: "#00917D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSvg);
export default __webpack_public_path__ + "static/media/ArrowSVG.25a0a159538f84025fe882c8ec0337af.svg";
export { ForwardRef as ReactComponent };